function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useEffect } from 'react';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { LoadingCircle } from "../../../../../a";
import { FormLabel, FormDescription } from "../../../..";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'single';

/**
 * This is the component description.
 */
const Single = ({
  id,
  className: userClassName,
  style,
  name,
  label,
  labelColor,
  color,
  options,
  hasDefault,
  validate,
  optional,
  description,
  disabled,
  isLoading,
  autoComplete,
  ...otherProps
}) => {
  const [field,, helpers] = useField({
    name,
    validate
  });
  const {
    setValue
  } = helpers;
  useEffect(() => {
    if (hasDefault && !field.value) {
      const defaultOption = options.find(option => option.isDefault);
      setValue(defaultOption?.value);
    }
  }, [hasDefault]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, label && /*#__PURE__*/React.createElement(FormLabel, {
    name: name,
    color: labelColor,
    optional: optional
  }, label), /*#__PURE__*/React.createElement("div", {
    className: `select-wrapper${disabled ? ' disabled' : ''}`
  }, /*#__PURE__*/React.createElement("select", _extends({
    className: `input y-${color}`
  }, field, {
    value: field.value || '',
    id: name,
    disabled: disabled,
    autoComplete: autoComplete
  }, otherProps), options.map(option => {
    // i.e if option is a string like "blah", return { value: "blah", label: "blah" }
    const newOption = typeof option === 'string' ? {
      value: option,
      label: option
    } : option;
    return /*#__PURE__*/React.createElement("option", {
      key: newOption.value,
      value: newOption.value,
      disabled: newOption?.disabled || false
    }, newOption.label);
  })), isLoading && /*#__PURE__*/React.createElement(LoadingCircle, {
    className: "x-main"
  })), /*#__PURE__*/React.createElement(FormDescription, {
    className: "s-1",
    description: description,
    name: name
  }));
};
Single.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The base color of the component
   */
  color: PropTypes.string
};
Single.defaultProps = {
  color: 'paragraph'
};
export default Single;